import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import _ChanceIcon from '@/assets/icons/icon_chance.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.li(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const ProgramWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['64px 1fr', '64px 1fr', '80px 1fr', '80px 1fr'],
    gridGap: [
      `0 ${defaultTheme.spacing.s}`,
      `0 ${defaultTheme.spacing.s}`,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
    ],
    '& > img': {
      width: ['64px', '64px', '80px', '80px'],
      margin: 'auto 0',
    },
  }),
);

export const DeadLine = styled.span(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
    ],
    color: defaultTheme.color.primary,
  }),
);

export const EndSaleText = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    color: defaultTheme.color.secondary,
  }),
);

export const ProgramInfoWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const ProgramInfo = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: 'auto 0',
  }),
);

export const RefundText = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    color: defaultTheme.text.gray,
  }),
);

export const RefundAmount = styled.span((props: { isChance?: boolean }) =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    color: props.isChance
      ? defaultTheme.color.primary
      : defaultTheme.color.secondary,
    margin: `${defaultTheme.spacing.xs} 0`,
  }),
);

export const StyledLink = styled(Link)(() =>
  mq({
    width: '110px',
    color: defaultTheme.text.white,
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    textAlign: 'center',
    backgroundColor: defaultTheme.background.primary,
    border: `1px solid ${defaultTheme.border.color.primary}`,
    borderRadius: defaultTheme.border.radius.m,
    padding: `${defaultTheme.spacing.xxl} 0`,
  }),
);

export const ChanceIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['32px', '32px', '48px', '48px'],
    height: ['32px', '32px', '48px', '48px'],
    backgroundImage: `url(${_ChanceIcon})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    marginLeft: defaultTheme.spacing.s,
  }),
);
